module.exports = __webpack_public_path__ + "static/tm-4c9a0e48b47ac6ee63cd2f6eb85e8fc5.svg";